import { render, staticRenderFns } from "./app-block-with-button.vue?vue&type=template&id=3cc45a5d&"
import script from "./app-block-with-button.vue?vue&type=script&lang=js&"
export * from "./app-block-with-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports